// Generated by purs version 0.13.0
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var outerRect = function (v) {
    return {
        a: {
            x: v.a.x - 1 | 0,
            y: v.a.y - 1 | 0
        },
        b: {
            x: v.b.x + 1 | 0,
            y: v.b.y + 1 | 0
        }
    };
};
var intersect = function (v) {
    return function (v1) {
        return !(v.a.x > v1.b.x || (v1.a.x > v.b.x || (v.a.y > v1.b.y || v1.a.y > v.b.y)));
    };
};
var innerRect = function (v) {
    return {
        a: {
            x: v.a.x + 1 | 0,
            y: v.a.y + 1 | 0
        },
        b: {
            x: v.b.x - 1 | 0,
            y: v.b.y - 1 | 0
        }
    };
};
var fillRect = function (v) {
    return Control_Bind.bind(Control_Bind.bindArray)(Data_Array.range(v.a.x)(v.b.x))(function (v1) {
        return Control_Bind.bind(Control_Bind.bindArray)(Data_Array.range(v.a.y)(v.b.y))(function (v2) {
            return Control_Applicative.pure(Control_Applicative.applicativeArray)({
                x: v1,
                y: v2
            });
        });
    });
};
var center = function (v) {
    return {
        x: Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(v.a.x + v.b.x | 0)(2),
        y: Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(v.a.y + v.b.y | 0)(2)
    };
};
module.exports = {
    center: center,
    fillRect: fillRect,
    innerRect: innerRect,
    intersect: intersect,
    outerRect: outerRect
};
